exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ==========================================================================\n   # Color Settings\n   ========================================================================== */\n/**\n * Set up a colour palette which allows us to theme the entire project from one\n * location.\n *\n */\n.c-titled-block__heading {\n  font-size: 1.2rem;\n  line-height: 1.7rem;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #828282;\n  margin-bottom: 10px; }\n", ""]);

// exports
